import React from "react"
import PropTypes from "prop-types"
import EnumSelectCell from "sheets/components/cells/EnumSelectCell"
import { Cell } from "fixed-data-table-2"
import Icon from "app/static/frontend/components/Icon"

export const ThumbsUpDownNeutralCell = ({ children, ...props }) => {
    const item = DjangIO.app.userdata.spreadsheet.types.ThumbType.by_value(Number(children))

    if (props.editing) {
        return (
            /* eslint-disable */
            <div
                // neccessary because the Select onClick() event propagates down to the SheetCell onClick() every time we click on a select,
                // which re-calls clickCell() after the unclickCell() action creator is fired in patchColumnData of sheet-action-creators
                // Since it is not possible to pass an onClick prop down to a react-select component, this is necessary
                // https://github.com/JedWatson/react-select/issues/532
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                }}
            >
                <EnumSelectCell
                    className="enumSelectCell"
                    choices={DjangIO.app.userdata.spreadsheet.types.ThumbType}
                    item={item}
                    clearable
                    {...props}
                />
            </div>
            /* eslint-enable */
        )
    } else {
        return (
            <Cell className="cell" {...props}>
                {typeof children === "number" && <Icon className="icon" name={item.icon} />}
            </Cell>
        )
    }
}

ThumbsUpDownNeutralCell.propTypes = {
    children: PropTypes.number,
}

export default ThumbsUpDownNeutralCell
